/**
 * @description 关于时间的Util
 */

import dayjs from "dayjs"

import { fZero } from "./util"

/**
 * 格式化时间返回
 * @param {Date} date 时间
 * @returns String xxxx年xx月xx日
 */
export function formatTime (date, format) {
    let now = new Date(date)
    let year = now.getFullYear()
    let month = fZero(now.getMonth() + 1)
    let _date = fZero(now.getDate())
    if (format) return `${year}${format}${month}${format}${_date}`
    return `${year}年${month}月${_date}日`
}

/**
 * 默认时间格式化
 * @param {String} date 2022-02-02
 * @param {DateFormat} formatStyle 'YYYY-MM-DD'
 */

export const formatBaseDateTime = (date, formatStyle = 'YYYY-MM-DD') => (dayjs(date).format(formatStyle))
